import * as React from 'react'

import { SnacksIcon, Strong, Text } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../common'

import Bullet from '../common/Bullet'
import { i18nKeyPrefix } from '../i18n'

const PRE = `${i18nKeyPrefix}-BASICS-SNACKS`

interface IProps {
  snacksProvidedCount: number
}

export default function Snacks(props: IProps) {
  const { snacksProvidedCount } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <Bullet icon={<SnacksIcon />}>
      <Strong>{t(`${PRE}-TEXT`)}</Strong>
      <Text muted>{t(`${PRE}-COUNT`, { snacksProvidedCount })}</Text>
    </Bullet>
  )
}
